var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('Banner',{attrs:{"background":(_vm.item.image) ? _vm.item.image : '',"title":(!_vm.pgLoading) ? (_vm.$i18n.locale == 'en') ? _vm.item.en.title : _vm.item.ar.title : ''}}),_c('WhoWeAre'),_c('OurValues'),_c('OurMission'),_c('OurTeam')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }